import React from "react";
import { Link } from "react-router-dom";
import Brand from "../components/Brand";
import Footer from "../components/Footer";

const Privacy = () => (
  <>
    <nav className="xnav">
      <div className="wrap nav-in">
        <Link to="/"><Brand /></Link>
        <div className="nav-links">
          <Link to="/" className="btn btn-ghost" style={{ padding: "11px 22px" }} data-testid="back-home-btn">
            Back to home
          </Link>
        </div>
      </div>
    </nav>
    <div className="legal" data-testid="privacy-page">
      <Link to="/" className="back">← Back</Link>
      <h1>Privacy Policy</h1>
      <p>
        <em>Last updated: December 2025</em>
      </p>
      <p>
        Xandi Beauty &amp; Wellness Hub Limited ("Xandi", "we", "us", or "our") respects your
        privacy and is committed to handling your personal information in accordance with{" "}
        <strong>Jamaica's Data Protection Act, 2020</strong>.
      </p>

      <h2>1. Information we collect</h2>
      <p>
        When you join our waitlist we collect your email address and your role preference
        (customer or provider). If you arrived via a referral link we also store the referral code
        that referred you so we can credit your friend.
      </p>

      <h2>2. How we use your information</h2>
      <ul>
        <li>To notify you when Xandi launches and when our booking platform opens.</li>
        <li>To deliver your WELCOME15 promo code and other early-member benefits.</li>
        <li>To measure waitlist demand and operate our "skip the line" referral programme.</li>
        <li>To comply with our legal obligations under Jamaican law.</li>
      </ul>

      <h2>3. Sharing</h2>
      <p>
        We do not sell your personal information. We share data only with service providers that
        help us operate (for example, email delivery and analytics), and only to the extent
        necessary.
      </p>

      <h2>4. Your rights under the DPA 2020</h2>
      <p>
        You have the right to access, correct, or request deletion of your personal information,
        and to withdraw consent at any time. To exercise these rights, email{" "}
        <a href="mailto:privacy@xandibwh.com">privacy@xandibwh.com</a>.
      </p>

      <h2>5. Cookies</h2>
      <p>
        We use a small number of cookies to remember your preferences (such as cookie consent) and
        to understand how visitors use the site. You can clear cookies at any time in your browser
        settings.
      </p>

      <h2>6. Contact</h2>
      <p>
        Xandi Beauty &amp; Wellness Hub Limited · Kingston, Jamaica ·{" "}
        <a href="mailto:privacy@xandibwh.com">privacy@xandibwh.com</a> · (876) 599-4444
      </p>

      <p>
        <em>
          This document is provided as placeholder legal text and will be updated before our
          public launch. Nothing here constitutes legal advice.
        </em>
      </p>
    </div>
    <Footer />
  </>
);

export default Privacy;
